import { CardImage } from './../shared/types';

export enum RoleRights {
  canCreateEvents,
  canReadEvents,
  canUpdateEvents,
  canDeleteEvents,
  canCreateUser,
  canReadUser,
  canUpdateUser,
  canDeleteUser,
  canManageParticipants,
  canManageSections,
  canManageSaisons
}

export interface Role {
  name: string;
  canCreateEvents?: boolean;
  canReadEvents?: boolean;
  canUpdateEvents?: boolean;
  canDeleteEvents?: boolean;
  seeUpTo?: number;
  canCreateUser?: boolean;
  canReadUser?: boolean;
  canUpdateUser?: boolean;
  canDeleteUser?: boolean;
  canManageParticipants?: boolean;
  canManageSections?: boolean;
  canManageSaisons?: boolean;
}

export interface User {
  id: string;
  image?: CardImage;
  username: string;
  password: string;
  email: string;
  role: Role;
  name: string;
}

export interface Guide {
  user: User;
  firstname: string;
  lastname: string;
}

export interface Business {
  user: User;
  name: string;
}

export enum TypeTranslations {
  'business' = 'Betrieb',
  'admin' = 'Admin',
  'guide' = 'Guide'
}

export const enum UserActionTypes {
  FETCH_REQUEST = '[user]FETCH_REQUEST',
  FETCH_SUCCESS = '[user]FETCH_SUCCESS',
  FETCH_ERROR = '[user]FETCH_ERROR',

  FETCH_REQUEST_AUTOCOMPLETE = '[user]FETCH_REQUEST_AUTOCOMPLETE',
  FETCH_SUCCESS_AUTOCOMPLETE = '[user]FETCH_SUCCESS_AUTOCOMPLETE',
  FETCH_ERROR_AUTOCOMPLETE = '[user]FETCH_ERROR_AUTOCOMPLETE',

  CLEAR_SUGGESTIONS = '[user]CLEAR_SUGGESTIONS',

  UPDATE_USER_SUCCESSFULL = '[user]UPDATE_USER_SUCCESSFULL'
}

export interface UserState {
  readonly loading: boolean;
  readonly suggestions: User[];
  readonly errors?: Error;
  readonly users: User[];
}



// WEBPACK FOOTER //
// ./src/store/user/types.ts